import { MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBFooter,  MDBRow, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {Redirect} from 'react-router-dom';
import 'date-fns';
import {
    KeyboardDatePicker,MuiPickersUtilsProvider
  } from '@material-ui/pickers';
  import DateFnsUtils from '@date-io/date-fns';


export class SubmitApplication extends React.Component {
    constructor(props) {
        super(props)
    
        this.state = {
             showProvider: false,
             scheduleDate: new Date(),
        }
    }

    handleScheduleDate = (date) =>{
        this.setState({scheduleDate: date})
    }
    

    render() {
        if(this.state.toTrackApplication){
            // console.log(this.state.toTrackApplication)
            return <Redirect to="/track-application" />
        }

        const data_panel = {
            columns: [
              {
                'label': <input type="checkbox" id="checkbox5" onClick={()=>this.setState({showProvider: true})} />,
                'field': 'check',
                'sort': 'asc',
              },
              {
                'label': 'Ref No',
                'field': 'ref_no',
                'sort': 'asc'
              },
              {
                'label': 'Passport',
                'field': 'passport',
                'sort': 'asc'
              },
              {
                'label': 'Destination',
                'field': 'destination',
                'sort': 'asc'
              },
              {
                'label': 'Visa Type',
                'field': 'visa_type',
                'sort': 'asc'
              },
              {
                'label': 'Name',
                'field': 'name',
                'sort': 'asc'
              },
              {
                'label': 'Nationality',
                'field': 'nationality',
                'sort': 'asc'
              },
              {
                'label': 'Date of Submission',
                'field': 'submission_date',
                'sort': 'asc'
              },
              {
                'label': 'Status',
                'field': 'status',
                'sort': 'asc'
              },
            ],
            rows: [
              {
                'check': <input type="checkbox" id="checkbox5" onClick={()=>this.setState({showProvider: true})} />,
                'ref_no': 'VIS1003',
                'passport': 'Z3274827',
                'destination': 'UAE',
                'visa_type': 'Express | Single',
                'name': 'AJAY MAMGAIN',
                'nationality': 'INDIAN',
                'submission_date': '1 June 2020',
                'status': <MDBBadge color="warning" >Pending</MDBBadge>,
              },
              {
                'check': <input type="checkbox" id="checkbox5" onClick={()=>this.setState({showProvider: true})} />,
                'ref_no': 'VIS1003',
                'passport': 'Z3274827',
                'destination': 'UAE',
                'visa_type': 'Express | Single',
                'name': 'AJAY MAMGAIN',
                'nationality': 'INDIAN',
                'submission_date': '1 June 2020',
                'status': <MDBBadge color="warning" >Pending</MDBBadge>,
              },
              
            ]
          };

          const dateFormat = (date) => {
            let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + (d.getDate()),
            year = '' + d.getFullYear();
      
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
            // console.log([year, month, day].join('-'))
            return [year, month, day].join('-');
          }

        return (
            <>
                <div>
                    <h4><b>Apply New Visa</b></h4>
                </div>
                <div className="mt-4">
                    <MDBCard>
                        <MDBCardBody cascade>
                            <MDBCardTitle>Basic Information</MDBCardTitle>
                            <hr/>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Country of Residence: </th><td>India</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling To: </th><td>United Arab Emirates</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Type: </th><td>Express | Single Entry</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Visa Duration: </th><td>14 Days</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Nationality: </th><td>Indian</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="3">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Applicants: </th><td>03</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                                <MDBCol size="12" lg="4">
                                    <MDBTable borderless>
                                        <tr>
                                            <th>Travelling Dates: </th><td>21 May 2021 To 07 June 2021</td>
                                        </tr>
                                    </MDBTable>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>  
                <div className="mt-4">
                    <MDBCard style={{marginBottom:'20rem'}}>
                        <MDBCardBody>
                            <MDBTable btn responsive >
                                <MDBTableHead columns={data_panel.columns} />
                                <MDBTableBody rows={data_panel.rows} />
                            </MDBTable>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                { this.state.showProvider &&
                <div className="mt-4">
                    <MDBCard >
                        <MDBCardBody>
                            <MDBCardTitle>Select one provider</MDBCardTitle>
                            <hr/>
                            <MDBRow>
                                <MDBCol size="12" sm="4" lg="3">
                                    <input type="radio" id="provider" name="provider" value="AHM"  defaultChecked/> AHM Tourism Dubai
                                </MDBCol>
                                <MDBCol size="12" sm="4" lg="3">
                                    <input type="radio" id="provider" name="provider" value="GDRFA"  defaultChecked/> GDRFA Dubai
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>
                }
                <div className="modal fade" id="scheduleModal" tabindex="-1" role="dialog" aria-labelledby="scheduleModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()}>
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            
                            <h4 className="modal-title" id="scheduleModalLabel"><b>Save as Draft</b></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                id="schedule-date"
                                label="Schedule Date"
                                value={dateFormat(this.state.scheduleDate)}
                                onChange={this.handleScheduleDate}
                                autoOk
                                style={{width:'100%'}}
                            />
                        </MuiPickersUtilsProvider>
                        <div>
                        <small>Select Time</small>
                        <Select 
                            id="time"
                            style={{ width:'100%',textAlign:'left', padding:0}}  
                            name="time"                                              
                            >
                            <MenuItem value="12 AM">12 AM</MenuItem>
                            <MenuItem value="1 AM">1 AM</MenuItem>
                            <MenuItem value="2 AM">2 AM</MenuItem>
                            <MenuItem value="12 PM">12 PM</MenuItem>
                        </Select>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}}>Cancel</MDBBtn>
                            {/* <RouterLink to="/track-application"> */}
                                <MDBBtn color="none" data-dismiss="modal" onClick={()=>{this.setState({toTrackApplication:true})}} style={{color:'white',backgroundColor:'#673784', textTransform:'none',}}>Schedule</MDBBtn>
                            {/* </RouterLink> */}
                        </div>
                    </div>
                </div>
                </div>
                <MDBRow>
                <MDBFooter style={{background: "#fff" ,  position: "fixed", bottom: "0px" ,width: "100%" , zIndex : "1" ,   left: "0" , right: "0" , borderTop: "1px solid #ccc" , boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)"}} color="white" className="pb-1 pt-1 text-right">

                        <MDBContainer>
                        <MDBRow>
                        <MDBCol size="12" xs="6" sm="6" md="8" lg="8" />
                        <MDBCol>
                            <MDBBtn id="scheduleBtn" data-toggle="modal" data-target="#scheduleModal" style={{color:'white',backgroundColor:'black',width:'100%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Schedule</MDBBtn>
                        </MDBCol>
                        <MDBCol >
                        <RouterLink to="/track-application"><MDBBtn id="submitBtn" style={{color:'white',backgroundColor:'#673784',width:'100%', fontSize:'calc(8px + .5rem)',textTransform:'none'}} color="none">Submit</MDBBtn></RouterLink>
                        </MDBCol>
                        </MDBRow>
                        </MDBContainer>
                    </MDBFooter>
                </MDBRow>
            </>
        )
    }
}

export default SubmitApplication;
